import { render, staticRenderFns } from "./LEDPCB65LessSplit.vue?vue&type=template&id=ce9ecdb4&scoped=true&"
import script from "./LEDPCB65LessSplit.vue?vue&type=script&lang=js&"
export * from "./LEDPCB65LessSplit.vue?vue&type=script&lang=js&"
import style0 from "./LEDPCB65LessSplit.vue?vue&type=style&index=0&id=ce9ecdb4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce9ecdb4",
  null
  
)

export default component.exports